module.exports = __webpack_public_path__ + "static/media/360-guide-desktop.cd551a19.png";